import React from "react";
import { Modal } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import * as Yup from "yup";
import { usePromoteUserMutation } from "../../../../../redux/apiSlice";
import TextInput from "../../../Common/components/text-input";
import SelectInput from "../../../Common/components/select-input";

const PromoteUserModal = ({ showPromoteUserModal, onHide, details }) => {
  const [promoteUser, { isLoading: isUpdating }] = usePromoteUserMutation();

  // Validation schema for the fee input field
  const validationSchema = Yup.object({
    fee: Yup.number()
      .required("Fee is required"),
  });

  const handlePromote = (values) => {
    const data = {
      userId: details?.userId,
      createdAt: details?.createdAt,
      profileId: details?.profileId,
      socialProvider: details?.socialProvider,
      suspensionDurationInDays: details?.suspensionDurationInDays,
      userGroup: details?.userGroup,
      fee: values.fee,
      currency: values.currency,
    };

    promoteUser(data)
      .unwrap()
      .then(() => {
        cogoToast.success("Promote User Action Created Successfully");
        onHide();
      })
      .catch(() => {
        cogoToast.error("Failed to promote user");
      });
  };

  return (
    <Modal
      show={showPromoteUserModal}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      backdrop={isUpdating ? "static" : true}
      keyboard={!isUpdating}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Promote User</Modal.Title>
        <button type="button" className="close" onClick={onHide}>
          <span aria-hidden="true" className="d-block">×</span>
          <span className="sr-only">Close</span>
        </button>
      </Modal.Header>

      <Formik
        initialValues={{
          fee: "",
          currency: "NGN",
        }}
        validationSchema={validationSchema}
        onSubmit={handlePromote}
      >
        {({ isValid }) => (
          <Form>
            <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
              <FormLayout.Row>
                <TextInput
                  label="Fee"
                  name="fee"
                  type="number"
                  placeholder="Enter fee amount"
                />
              
              <SelectInput
                label="CURRENCY"
                name="currency"
                options={["NGN", "USD"]}
              />
              </FormLayout.Row>

              <p>
                Are you sure you want to promote <strong>{details.username}</strong> to a power user?
              </p>


            </Modal.Body>

            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
                disabled={isUpdating}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
                disabled={isUpdating || !isValid}
              >
                Promote
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default PromoteUserModal;
